<!-- ATOM: GlobalSnackbar.vue -->

<script setup lang="ts">
//
// Composables
//
const {
  snackbar,
  snackbarText,
  snackbarColor,
  snackbarTimeout,
  snackbarIcon,
  snackbarActionText,
  snackbarActionHandler,
  hideSnackbar,
} = useSnackbar();

function handleAction(): void {
  snackbarActionHandler.value?.();
  hideSnackbar();
}
</script>

<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="snackbarTimeout"
    :color="snackbarColor"
    location="bottom"
    rounded="lg"
  >
    <div class="d-flex align-center ga-2">
      <v-icon v-if="snackbarIcon" :icon="snackbarIcon" size="small" />
      <span>{{ snackbarText }}</span>
    </div>

    <template v-if="snackbarActionText" #actions>
      <v-btn rounded="lg" variant="flat" color="white" size="small" @click="handleAction">
        {{ snackbarActionText }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
